export class PhoneNumberInfoResponse {
    DisplayPhoneNumber: string | null;
    PlatformType: string | null;
    Throughput: string | null;
    PhoneNumberWebhook: string | null;
}